// extracted by mini-css-extract-plugin
export default {"redBg":"app-portainer-components-ReactExample-module__red-bg"};